import { BaseService } from "services/_baseService";

class SubscriptionService extends BaseService<any> {
    constructor() {
        super(`subscriptions`);
    }
}

export default new SubscriptionService();